import { env } from '@/shared/lib/env';

export const setSubdomainName = (subDomain: string, inCore: boolean) => {
  // Create a new URL object with the updated values
  const updatedURL = new URL(window.location.href);

  updatedURL.hostname =
    subDomain !== '' && !inCore
      ? `${subDomain}.${env.VITE_FRONTEND_CORE_HOSTNAME}`
      : env.VITE_FRONTEND_CORE_HOSTNAME;

  // Navigate to the updated URL
  window.location.href = updatedURL.href;
};
